/* eslint-disable */
import { notification } from 'antd';
import { getDataSource, getMe } from 'legacy/store/appReducer';
import { DATASOURCES } from 'legacy/constants';
import {
  fetchWorkListCCT,
  fetchWorkListCCTFilterDropdown,
  fetchCCTAnotator,
  fetchBaseRhythmDropdown,
  submitCCTAnotator,
} from 'legacy/containers/ApiUrls';
import history from '../../../legacy/containers/History';
import { updateRxPatient } from '../KardiaRxCCTPatientHistory/KardiaRxCCTPatientHistoryActions';
import ROUTE_PATHS from '../../../routes/routePaths';
// URL functions

// Constants Types
import {
  CCT_WORKLIST_DATA_REQUEST,
  CCT_WORKLIST_DATA_SUCCESS,
  CCT_WORKLIST_DATA_FAILURE,
  CCT_WORKLIST_DD_REQUEST,
  CCT_WORKLIST_DD_SUCCESS,
  CCT_WORKLIST_DD_FAILURE,
  CCT_WORKLIST_FILTER_DROPDOWN_SUCCESS,
  CCT_WORKLIST_FILTER_DROPDOWN_VALUE_SUBMIT,
  CCT_WORKLIST_FILTER_CLEAR,
  CCT_WORKLIST_PAGINATION_TOKEN_CLEAR,
  CCT_WORKLIST_PAGINATION_TOKEN_ADD,
  CCT_WORKLIST_PAGINATION_TOKEN_REMOVE,
  CCT_PAGE_NO_UPDATE,
  CCT_Practice_Id_UPDATE,
  CCT_SELECTED_VALUE_ON_SUBMIT_CLEAR,
  CCT_Provider_Id_UPDATE,
  CCT_WORKLIST_DD_FAILURE_RE_ROUTE,
  CCT_WORKLIST_DD_FAILURE_RE_ROUTE_CLEAR,
  CCT_WORKLIST_CORRUPTED_DATA_REQUEST,
  CCT_WORKLIST_CORRUPTED_DATA_SUCCESS,
} from './types';

// ------------------------------------
// Actions
// ------------------------------------
export const kardiRxCCTWorklistDataRequest = () => ({
  type: CCT_WORKLIST_DATA_REQUEST,
});
export const kardiRxCCTWorklistDataSuccess = data => ({
  type: CCT_WORKLIST_DATA_SUCCESS,
  payload: data,
});
export const kardiRxCCTWorklistDataFailure = () => ({
  type: CCT_WORKLIST_DATA_FAILURE,
});

export const kRxCCTWorklistDDRequest = () => ({
  type: CCT_WORKLIST_DD_REQUEST,
});
export const kRxCCTWorklistDDSuccess = data => ({
  type: CCT_WORKLIST_DD_SUCCESS,
  payload: data,
});
export const kRxCCTWorklistDDFailure = () => ({
  type: CCT_WORKLIST_DD_FAILURE,
});
export const kRxCCTWorklistReRouteError = () => ({
  type: CCT_WORKLIST_DD_FAILURE_RE_ROUTE,
});
export const kardiRxCCTWorklistCorruptedDataRequest = () => ({
  type: CCT_WORKLIST_CORRUPTED_DATA_REQUEST,
});
export const kardiRxCCTWorklistCorruptedDataSuccess = () => ({
  type: CCT_WORKLIST_CORRUPTED_DATA_SUCCESS,
});

export const getKardiaRxCCTWorklistData = (
  forceUpdate = false,
  dropDownValue = 1,
  pageLimt = 100,
  page = 1,
  paginationToken = '',
  identifier,
) => (dispatch, getState) => {
  dispatch(kardiRxCCTWorklistDataRequest());
  dispatch(pageNoUpdate(page));
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  dispatch(getKardiaRxCCTWorklistFilterDropdown());

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const practiceID =
        getState() &&
        getState().kardiaRx &&
        getState().kardiaRx.kardiaRxCCTWorklist &&
        getState().kardiaRx.kardiaRxCCTWorklist.practiceId
          ? getState() &&
            getState().kardiaRx &&
            getState().kardiaRx.kardiaRxCCTWorklist &&
            getState().kardiaRx.kardiaRxCCTWorklist.practiceId
          : '';
      const orderingPhysicianID =
        getState() &&
        getState().kardiaRx &&
        getState().kardiaRx.kardiaRxCCTWorklist &&
        getState().kardiaRx.kardiaRxCCTWorklist.providerId
          ? getState() &&
            getState().kardiaRx &&
            getState().kardiaRx.kardiaRxCCTWorklist &&
            getState().kardiaRx.kardiaRxCCTWorklist.providerId
          : '';

      const identifierReducer =
        (getState() &&
          getState().kardiaRx &&
          getState().kardiaRx.kardiaRxCCTWorklist &&
          getState().kardiaRx.kardiaRxCCTWorklist.selectedvalueOnSubmit &&
          getState().kardiaRx.kardiaRxCCTWorklist.selectedvalueOnSubmit
            .patients) ||
        '';

      let identifierMrn;
      if (identifierReducer) {
        const valueArray = identifierReducer.split(' [');
        const mrnIdentifier =
          valueArray[1] && valueArray[1].substring(0, valueArray[1].length - 1);
        if (mrnIdentifier) {
          const mrnValue = mrnIdentifier.split(':')[1];
          identifierMrn = mrnValue;
        } else {
          identifierMrn = identifierReducer;
        }
      } else {
        identifierMrn = '';
      }

      const { teams } = me.data;
      const apiCalls = [];
      apiCalls.push(
        dispatch(
          fetchWorkListCCT(
            teams[0].id,
            dropDownValue,
            pageLimt,
            page,
            paginationToken,
            identifierMrn,
            practiceID,
            orderingPhysicianID,
          ),
        ),
      );
      return Promise.all(apiCalls);
    })
    .then(data => {
      const { token } = data[0];
      dispatch(paginationTokenAdd(token));
      return data[0].dataList;
      // const dataTemp = data[0].dataList.then(res => res)
      // console.log('datadataTemp', dataTemp);

      // return dispatch(kardiRxCCTWorklistDataSuccess(dataTemp));
    })
    .then(response => {
      return dispatch(kardiRxCCTWorklistDataSuccess(response));
    })
    .catch(err => {
      dispatch(kardiRxCCTWorklistDataFailure());
    });
};

export const handleOnRefreshClick = () => (dispatch, getState) => {
  const dropDownValue =
    getState() &&
    getState().kardiaRx &&
    getState().kardiaRx.kardiaRxCCTWorklist &&
    getState().kardiaRx.kardiaRxCCTWorklist.selectedFilterDropdown
      ? getState() &&
        getState().kardiaRx &&
        getState().kardiaRx.kardiaRxCCTWorklist &&
        getState().kardiaRx.kardiaRxCCTWorklist.selectedFilterDropdown
      : 1;

  dispatch(getKardiaRxCCTWorklistData(true, dropDownValue));
};

export const getKardiaRxCCTWorklistFilterDropdown = (forceUpdate = false) => (
  dispatch,
  getState,
) => {
  dispatch(kRxCCTWorklistDDRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }
  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { teams } = me.data;
      const apiCalls = [];
      apiCalls.push(dispatch(fetchWorkListCCTFilterDropdown(teams[0].id)));
      return Promise.all(apiCalls);
    })
    .then(data => {
      return dispatch(kRxCCTWorklistDDSuccess(data[0]));
    })
    .catch(err => {
      dispatch(kRxCCTWorklistDDFailure());
    });
};

export const updateSelectedFilterDropdown = data => (dispatch, getState) => {
  dispatch(getKardiaRxCCTWorklistData(false, data)).then(() => {
    dispatch(updateSelectedFilterDropdownValue(data));
  });
};
export const updateSelectedFilterDropdownValue = data => ({
  type: CCT_WORKLIST_FILTER_DROPDOWN_SUCCESS,
  payload: data,
});

export const searchSubmit = data => ({
  type: CCT_WORKLIST_FILTER_DROPDOWN_VALUE_SUBMIT,
  payload: data,
});

export const searchClear = () => ({
  type: CCT_WORKLIST_FILTER_CLEAR,
});

export const reRouteErrorClear = () => ({
  type: CCT_WORKLIST_DD_FAILURE_RE_ROUTE_CLEAR,
});

export const paginationTokenClear = () => ({
  type: CCT_WORKLIST_PAGINATION_TOKEN_CLEAR,
});

export const paginationTokenAdd = token => ({
  type: CCT_WORKLIST_PAGINATION_TOKEN_ADD,
  payload: token,
});

export const routeChangeAction = (RecordingID, data) => (
  dispatch,
  getState,
) => {
  let apiResponse;
  // push the selected data - patient data to the action to update redux-kardiaRxCCTPatientHistory state
  dispatch(updateRxPatient(data.patient));
  // history.push(
  //   `${ROUTE_PATHS.EKG_REVIEW_EKG_ANNOTATION}/${RecordingID}/${data.patient.id}/${data.patient.connection_template_id}`,
  // );
  dispatch(kardiRxCCTWorklistCorruptedDataRequest())
  dispatch(fetchCCTAnotator(RecordingID)).then((res)=>{
    apiResponse = res;
    return res
  }).then((response)=>{
    return dispatch(fetchBaseRhythmDropdown())
  }).then(()=>{
    dispatch(kardiRxCCTWorklistCorruptedDataSuccess())
    if (apiResponse.payload && apiResponse.payload.recording && apiResponse.payload.recording.status ==='empty_recording' || apiResponse.payload && apiResponse.payload.recording && apiResponse.payload.recording.status ==='corrupted_recording') {
      dispatch(kRxCCTWorklistReRouteError())
    } else {
      return history.push(
        `${ROUTE_PATHS.EKG_REVIEW_EKG_ANNOTATION}/${RecordingID}/${data.patient.idtf_connection_id}`,
      )
    }
  }).catch((err)=>{
    dispatch(kardiRxCCTWorklistCorruptedDataSuccess())
    console.log("err=>>>>>", err);
      notification['error']({
        description: 'Something went wrong',       
      });
    // dispatch(kRxCCTWorklistReRouteError())
  })
  

  // history.push(
  //   `${ROUTE_PATHS.EKG_REVIEW_EKG_ANNOTATION}/${RecordingID}/${data.patient.idtf_connection_id}`,
  // );

};

export const getKardiaRxCCTWorklistDataPaginationPrevious = (
  forceUpdate = false,
  dropDownValue = 1,
  pageLimt = 100,
  page = 1,
  paginationToken = '',
) => (dispatch, getState) => {
  dispatch(kardiRxCCTWorklistDataRequest());
  dispatch(pageNoUpdate(page));
  dispatch(paginationTokenRemove(2));
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  dispatch(getKardiaRxCCTWorklistFilterDropdown());

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { teams } = me.data;
      const apiCalls = [];
      apiCalls.push(
        dispatch(
          fetchWorkListCCT(
            teams[0].id,
            dropDownValue,
            pageLimt,
            page,
            paginationToken,
          ),
        ),
      );
      return Promise.all(apiCalls);
    })
    .then(data => {
      const { token } = data[0];
      dispatch(paginationTokenAdd(token));
      return data[0].dataList;
    })
    .then(response => {
      return dispatch(kardiRxCCTWorklistDataSuccess(response));
    })
    .catch(err => {
      dispatch(kardiRxCCTWorklistDataFailure());
    });
};

export const paginationTokenRemove = remove => ({
  type: CCT_WORKLIST_PAGINATION_TOKEN_REMOVE,
  payload: remove,
});

export const pageNoUpdate = page => ({
  type: CCT_PAGE_NO_UPDATE,
  payload: page,
});

export const practiceIdUpdate = id => ({
  type: CCT_Practice_Id_UPDATE,
  payload: id,
});

export const providerIdUpdate = id => ({
  type: CCT_Provider_Id_UPDATE,
  payload: id,
});

export const slectedValueONSubmitClear = () => ({
  type: CCT_SELECTED_VALUE_ON_SUBMIT_CLEAR,
});


export const handleOkForSendToArchive = () => (
  dispatch,
  getState,
) => {
  
  // const RecordingID =
  //   getState() &&
  //   getState().kardiaRx &&
  //   getState().kardiaRx.kardiaRxCCTPatientHistory &&
  //   getState().kardiaRx.kardiaRxCCTPatientHistory.selectedPatinet &&
  //   getState().kardiaRx.kardiaRxCCTPatientHistory.selectedPatinet.id


    const RecordingID =
    getState() &&
    getState().annotator &&
    getState().annotator.recordingInfo &&
    getState().annotator.recordingInfo.annotation &&
    getState().annotator.recordingInfo.annotation.recordingId


    const recordingInfo =  getState() && getState().annotator && getState().annotator.recordingInfo

    const payload = {
      ...recordingInfo.annotation,
      inbox: 5,
    };

    dispatch(submitCCTAnotator(RecordingID, payload))
      .then(res => {
        if(res.payload && res.payload.errors){
          console.log("resss", res.payload && res.payload.errors);
              // dispatch(reRouteErrorClear());
        } else {
         dispatch(handleOnRefreshClick());
        dispatch(reRouteErrorClear());
        }
      })
      .catch(err => {
        console.log('errrrrroorr', err);
        // dispatch(kRxCCTWorklistReRouteError())
      });
}


// WEBPACK FOOTER //
// ./src/views/state/kardiaRxCCTWorklist/KardiaRxCCTWorklistActions.js